export const adminStackLinking = {
    screens: {
        Admin_Home: {
            path: 'admin/home',
        },
        Admin_Notes: {
            path: 'admin/notes',
        },
        Admin_NoteEditor: {
            path: 'admin/notes/:noteID',
        },
    },
};
export const adminTabsLinking = {
    screens: {
        Admin_Home: {
            path: 'admin/*',
        },
    },
};
